// frontend/src/config/api.config.ts
/**
 * Pensado por: Alcélio Gomes
 * Codificado em coautoria: Claude Code
 * 🚀 NeuroAgentes
 * 
 * AUDITORIA: Configuração central de API e helpers para o frontend.
 */

import { API_ENDPOINTS } from './api/endpoints';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';

export const API_CONFIG = {
  baseURL: BACKEND_URL,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
};

export { API_ENDPOINTS };

export function buildApiUrl(endpoint: string): string {
  return BACKEND_URL + endpoint;
}

export function getBackendUrl(): string {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }

  return window.location.origin;
}

export function addCsrfToken(headers: Record<string, string>, csrfToken: string): Record<string, string> {
  return {
    ...headers,
    'X-CSRF-Token': csrfToken,
  };
}

export const FILE_UPLOAD_CONFIG = {
  ...API_CONFIG,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  maxContentLength: 50 * 1024 * 1024,
  maxBodyLength: 50 * 1024 * 1024,
};

export const CAIXAS_VALIDATION = {
  ESTACAO_ID: {
    MIN: Number(process.env.REACT_APP_ESTACAO_ID_MIN) || 3,
    MAX: Number(process.env.REACT_APP_ESTACAO_ID_MAX) || 50,
    PATTERN: /^[a-z0-9_]{3,50}$/
  },
  NOME_ESTACAO: {
    MIN: Number(process.env.REACT_APP_NOME_ESTACAO_MIN) || 1,
    MAX: Number(process.env.REACT_APP_NOME_ESTACAO_MAX) || 100
  },
  PAPEL_WIDTH: {
    MIN: Number(process.env.REACT_APP_PAPEL_WIDTH_MIN) || 20,
    MAX: Number(process.env.REACT_APP_PAPEL_WIDTH_MAX) || 80,
    DEFAULT: Number(process.env.REACT_APP_PAPEL_WIDTH_DEFAULT) || 32
  },
  TIMEOUT_PRINT: {
    MIN: Number(process.env.REACT_APP_TIMEOUT_PRINT_MIN) || 1000,
    MAX: Number(process.env.REACT_APP_TIMEOUT_PRINT_MAX) || 30000,
    DEFAULT: Number(process.env.REACT_APP_TIMEOUT_PRINT_DEFAULT) || 5000
  },
  CNPJ_PATTERN: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
  EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  MESSAGES: {
    ESTACAO_ID_INVALID: 'ID da estação deve conter apenas letras minúsculas, números e underscore (3-50 caracteres)',
    NOME_ESTACAO_REQUIRED: 'Nome da estação é obrigatório',
    CNPJ_INVALID: 'CNPJ deve estar no formato 00.000.000/0000-00',
    EMAIL_INVALID: 'Email deve ter um formato válido',
    PAPEL_WIDTH_RANGE: (min: number, max: number) => `Largura do papel deve estar entre ${min} e ${max} caracteres`,
    TIMEOUT_PRINT_RANGE: (min: number, max: number) => `Timeout de impressão deve estar entre ${min}ms e ${max}ms`
  }
} as const;

export default API_CONFIG;
